import {useEffect} from 'react';

const useAppVisibilityChange = ({onVisible, onHidden}) => {
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            onVisible?.();
        } else {
            onHidden?.();
        }
    };

    useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
};

export default useAppVisibilityChange;
